import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { FilmCustomActionListAction } from './subcomponents/action';
const b = bemClassBuilder('v-film-custom-action-list');
export const FilmCustomActionList = observer(() => {
    const { film: filmConfig } = useOccConfig();
    const { film } = useFilmContext();
    if (!film)
        return null;
    const filmCustomActions = filmConfig.customActions[film.id];
    if (!filmCustomActions)
        return null;
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: filmCustomActions.map((customAction, index) => (_jsx("li", Object.assign({ className: b.element('item') }, { children: _jsx(FilmCustomActionListAction, { film: film, customAction: customAction }) }), `action-${index}`))) })));
});
FilmCustomActionList.displayName = 'FilmCustomActionList';
/**
 * The **Film Custom Action List** component renders a list of custom actions for the film.
 *
 * If there are no custom actions configured for the film, then the **Film Custom Action List** component will not render.
 */
export const FilmCustomActionListComponent = withComponentWrapper(FilmCustomActionList, {}, () => true);
